import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  activeBookId: null,
  uploadingCoverImage: false,
  uploadingImages: [], // For individual image tracking (legacy polling)
  uploadingImagesBatch: false, // 🆕 For batch upload status (Socket.IO)
  uploadingNewImages: [],
  steps: [], // fetched from /steps/list
  currentStepIndex: 0, // local index
  currentStepId: null, // backend stepId
  isComingFromNonUserRoute: false,
  forceBookRefresh: 0,
};

const stepSlice = createSlice({
  name: "stepFlow",
  initialState,
  reducers: {
    setSteps: (state, action) => {
      state.steps = action.payload;
    },
    setCurrentStep: (state, action) => {
      state.currentStepIndex = action.payload.index;
      state.currentStepId = action.payload.stepId;
    },
    setActiveBookId: (state, action) => {
      state.activeBookId = action.payload.bookId;
    },
    setForceBookRefresh: (state, action) => {
      state.forceBookRefresh = state.forceBookRefresh + action.payload
    },
    setCoverImageUploadStatus: (state, action) => {
      state.uploadingCoverImage = !!action.payload
    },
    // 🔧 FIXED: For individual image tracking (legacy polling)
    setImageUploadStatus: (state, action) => {
      // Handle both old format { type: 'add', id: ... } and new format (boolean)
      if (typeof action.payload === 'boolean') {
        // New Socket.IO format - use batch flag
        state.uploadingImagesBatch = action.payload;
      } else if (action.payload.type === 'add') {
        state.uploadingImages = [...state.uploadingImages, action.payload.id];
      } else if (action.payload.type === 'remove') {
        state.uploadingImages = state.uploadingImages.filter(img => img !== action.payload.id);
      }
    },
    // 🆕 NEW: Dedicated action for batch upload status
    setImageBatchUploadStatus: (state, action) => {
      state.uploadingImagesBatch = !!action.payload;
    },
    setMultiNewImages: (state, action) => {
      state.uploadingNewImages = [...state.uploadingNewImages, ...action.payload]
    },
    setNewImageUploadStatus: (state, action) => {
      state.uploadingNewImages = action.payload.type === 'add' 
        ? [...state.uploadingNewImages, action.payload.id] 
        : state.uploadingNewImages.filter(img => img !== action.payload.id)
      console.log('updated one', state.uploadingNewImages)
    },
    setIsComingFromNonUserRoute: (state, action) => {
      state.isComingFromNonUserRoute = !!action.payload
    },
    resetStep: (state, action) => {
      state.activeBookId = null
      state.uploadingCoverImage = false
      state.uploadingImages = []
      state.uploadingImagesBatch = false
      state.uploadingNewImages = []
    },
    setUploadingImages: (state, action) => {
      state.uploadingImages = [...state.uploadingImages, (action.payload || [])]
    },
    clearUploadingImages: (state, action) => {
      state.uploadingImages = []
    },
  },
});

export const { 
  setSteps, 
  setCurrentStep, 
  setActiveBookId, 
  setForceBookRefresh, 
  setCoverImageUploadStatus, 
  setImageUploadStatus, 
  setImageBatchUploadStatus, // 🆕 Export new action
  setNewImageUploadStatus, 
  setIsComingFromNonUserRoute, 
  resetStep, 
  setMultiNewImages,
  setUploadingImages,
  clearUploadingImages
} = stepSlice.actions;

export default stepSlice.reducer;